import Vue from 'vue'

const setBoxes = (state, { boxes }) => {
  state.boxes = boxes;
};

const setCountBoxes = (state, countBoxes) => {
  state.countBoxes = countBoxes;
};

const updateStatusBoxesToReq = (state, listBoxes) => {
  listBoxes.forEach(cbox => {
    const box = state.boxes.find(box => box.code === cbox.box);

    if (box) {
      const file = box.files.find(fil => fil.id === cbox.id);
      if (file) {
        Vue.set(file, 'status', 'req');
      }

      if (box.status !== 'req') {
        Vue.set(box, 'status', 'req');
      }
    }
  });
};

export default {
  setBoxes,
  setCountBoxes,
  updateStatusBoxesToReq
};



// WEBPACK FOOTER //
// ./src/store/modules/boxes/mutations.js